'use es6';

import Interframe from 'interframe';
import debounce from 'transmute/debounce';
import { getNewFormPreviewUrl } from 'FormsUI/utils/UrlUtils';
const iframeUrl = getNewFormPreviewUrl();
class EventBus {
  constructor() {
    this.postMessage = debounce(100, message => {
      this.queuedMessage = message;
      if (!this.isReady) {
        return;
      }
      if (this.messenger) {
        this.messenger.postMessage(message);
      }
      if (this.secondaryMessanger) {
        this.secondaryMessanger.postMessage(message);
      }
    });
    this.receiveMessage = message => {
      if (message.source !== 'preview') {
        return;
      }
      this.store.dispatch(message);
    };
    this.queuedMessage = null;
    this.isReady = false;
    this.secondaryMessanger = null;
    this.messenger = null;
    this.store = null;
  }
  setStore(store) {
    this.store = store;
  }
  onParentReady(targetOrigin, isSecondary) {
    this.isReady = true;
    const messenger = new Interframe(iframeUrl, targetOrigin);
    if (!isSecondary) {
      messenger.subscribe(this.receiveMessage);
    }
    if (this.queuedMessage) {
      this.postMessage(this.queuedMessage);
    }
    if (isSecondary) {
      this.secondaryMessanger = messenger;
    } else {
      this.messenger = messenger;
    }
  }
  resetSecondary() {
    this.secondaryMessanger = null;
  }
}
export default new EventBus();